const applyFn = (state, fn) => fn(state);
const pipe = (fns, state) => state.withMutations((state) => fns.reduce(applyFn, state));

export default pipe;



// WEBPACK FOOTER //
// ./src/helpers/redux-state-mutators.js